module.exports = __webpack_public_path__ + "static/media/haribo.8006ef9a.jpg";